import React from 'react';
import { ShimmerSkeleton } from './BaseSkeleton';

const ListItemSkeleton = ({ showAvatar = false, showActions = true }) => {
  return (
    <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-gray-200">
      {showAvatar && (
        <ShimmerSkeleton width="w-12" height="h-12" rounded="rounded-full" />
      )}
      
      <div className="flex-1 space-y-2">
        <ShimmerSkeleton width="w-1/2" height="h-4" rounded="rounded" />
        <ShimmerSkeleton width="w-3/4" height="h-3" rounded="rounded" />
      </div>
      
      {showActions && (
        <div className="flex gap-2">
          <ShimmerSkeleton width="w-8" height="h-8" rounded="rounded" />
          <ShimmerSkeleton width="w-8" height="h-8" rounded="rounded" />
        </div>
      )}
    </div>
  );
};

const ListSkeleton = ({ 
  items = 5, 
  showAvatar = false, 
  showActions = true,
  showHeader = true 
}) => {
  return (
    <div className="space-y-4">
      {showHeader && (
        <div className="flex items-center justify-between mb-6">
          <ShimmerSkeleton width="w-32" height="h-6" rounded="rounded" />
          <ShimmerSkeleton width="w-20" height="h-8" rounded="rounded-full" />
        </div>
      )}
      
      {Array.from({ length: items }).map((_, index) => (
        <ListItemSkeleton 
          key={index} 
          showAvatar={showAvatar} 
          showActions={showActions} 
        />
      ))}
    </div>
  );
};

export { ListItemSkeleton };
export default ListSkeleton;